module.exports = __webpack_public_path__ + "static/media/hrcom-vid.60d5f16c.mp4";